import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Switch from 'flarum/common/components/Switch';
export default function () {
  extend('flarum/forum/components/SettingsPage', 'notificationsItems', function (items) {
    var _preferences;
    items.add('followAfterReply', m(Switch, {
      state: this.user.preferences().followAfterReply,
      onchange: value => {
        this.followAfterReplyLoading = true;
        this.user.savePreferences({
          followAfterReply: value
        }).then(() => {
          this.followAfterReplyLoading = false;
          m.redraw();
        });
      },
      loading: this.followAfterReplyLoading
    }, app.translator.trans('flarum-subscriptions.forum.settings.follow_after_reply_label')));
    items.add('notifyForAllPosts', m(Switch, {
      id: "flarum_subscriptions__notify_for_all_posts",
      state: !!((_preferences = this.user.preferences()) != null && _preferences['flarum-subscriptions.notify_for_all_posts']),
      onchange: val => {
        this.notifyForAllPostsLoading = true;
        this.user.savePreferences({
          'flarum-subscriptions.notify_for_all_posts': val
        }).then(() => {
          this.notifyForAllPostsLoading = false;
          m.redraw();
        });
      },
      loading: this.notifyForAllPostsLoading
    }, app.translator.trans('flarum-subscriptions.forum.settings.notify_for_all_posts_label')));
  });
}